const NoisemeterV2 = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='FrontPage--Riddle__Screen__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/background.png' className='FrontPage--Riddle__Screen__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/background.png' className='FrontPage--Riddle__Screen__Background__Image' />
                )}
            </div>

            <div className="FrontPageNoisemeter__Screen__Container">
                <img src='/img/page/adsl-five.png' className='FrontPageNoisemeter__Screen__Container__Logo' />
                <p className="FrontPageNoisemeter__Screen__Container__Title" style={{ fontFamily: '"GFS Didot", serif' }}>RUIDÓMETRO</p>
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { NoisemeterV2 };
